module.exports = __webpack_public_path__ + "static/media/cartoon.778c58e7.jpg";